import React from "react";
//import { useSelector } from "react-redux";
import Form from "./components/Form";
import Header from "./components/header/Header";

import "./App.css";
import { setDefaultLanguage, setDefaultTranslations } from "react-multi-lang";
import eng from "./assets/transations/en.json";
import fra from "./assets/transations/french.json";
import esn from "./assets/transations/spanish.json";
import ita from "./assets/transations/italian.json";
import rus from "./assets/transations/russian.json";
import jpn from "./assets/transations/japan.json";
import ger from "./assets/transations/dutch.json";
import kor from "./assets/transations/korean.json";
import cht from "./assets/transations/tradition-chinees.json";
import chs from "./assets/transations/simple-chinees.json";
import { Switch, Route, withRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

function App(props) {
  setDefaultTranslations({
    eng,
    ger,
    fra,
    esn,
    ita,
    rus,
    jpn,
    kor,
    cht,
    chs,
  });

  let lng = props.location.search.replace("?lang:", "");
  if (lng) {
    setDefaultLanguage(lng);
  } else {
    setDefaultLanguage("eng");
  }

  return (
    <HelmetProvider>
      <div className="body-page">
        <Header />
        <Switch>
          <Route component={Form} path={"/"} exact />
        </Switch>
      </div>
    </HelmetProvider>
  );
}

export default withRouter(App);
